<script setup lang="ts">
import * as Session from 'supertokens-web-js/recipe/session';
import {computed, onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import {AvailabilityState, CabMe} from 'common';
import {getMeInfo} from '@/base/me.js';
import {stateForReporters} from '@/base/TMP_globalState.js';

const router = useRouter();

const meInfo         = ref<CabMe | undefined>(undefined);
const userName       = computed(() => getUserName());
const userPermission = computed(() => getUserPermission());

onMounted(async () => {
    meInfo.value = await getMeInfo();
});

async function onLogout() {
    await Session.signOut();
    router.push('/');
}

function getUserName() {
    const f = meInfo.value?.first_name;
    const l = meInfo.value?.last_name;
    if (f || l) {
        return `${f} ${l}`;
    } else {
        return meInfo.value?.emails?.[0] ?? '?';
    }
}

function getUserPermission() {
    const mePerm     = meInfo.value?.permissions;
    let post: string = '';
    if (mePerm?.includes('report') ?? false) {
        switch (stateForReporters.value) {
            case AvailabilityState.closed:
                post = ' (geen-toegang)';
                break;
            case AvailabilityState.read:
                post = ' (alleen-lezen)';
                break;
        }
    }
    return mePerm?.join() + post;
}
</script>

<template>
    <div class="flex flex-col p-2 m-2 bg-gray-100 min-w-60 space-y-1">
        <div class="text-xs text-gray-600 flex-1 text-center">
            {{ userName }}
        </div>
        <div class="text-xs text-gray-600 flex-1 text-center">
            {{ userPermission }}
        </div>
        <button
            class="w-full bg-green-600 hover:bg-green-700 text-white text-xs font-bold py-1 px-2 rounded cursor-pointer"
            @click="onLogout"
        >
            Uitloggen
        </button>
    </div>
</template>
